document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".announcement-bar-seg-custom__item");
  if (!items.length) return;

  let index = 0;

  function showItem(i) {
    items.forEach((el, idx) => {
      el.classList.toggle("active", idx === i);
    });
  }

  showItem(index);

  setInterval(function () {
    index = (index + 1) % items.length;
    showItem(index);
  }, 4000);
});
